@if (op_popup_data && op_popup_data.pa && !eye_popup && !isoptical && !is_op_fSixty) {
  <div>
    @if (op_popup_data.pa) {
      <div class="custom-pad ml-3 mt-2">
        @if (op_popup_data.isPa) {
          <div class="kx-control col-12 col-sm-4">
            <label>Payer</label>
            <select class="form-control" (change)="onItemSelect($event)">
              <option value="" [disabled]="true">Select Payer Name</option>
              @for (payer of op_popup_data.pa; track payer) {
                <option [value]="payer.payer_id">{{payer.payer_name}}
                </option>
              }
            </select>
          </div>
        }
        @if (op_popup_data.isDa) {
          <div class="kx-control col-12 col-sm-4">
            <label [ngClass]="treatingDoctorConfig?'required':''">Treating Doctor</label>
            <select class="form-control required" (change)="ontreatingSelect($event)" required="required">
              <option value="" [disabled]="true">Select Treating Doctor</option>
              @for (treat of op_popup_data.da; track treat) {
                <option [value]="treat.treatingDoctorId">{{treat.treatingDoctor}}
                </option>
              }
            </select>
          </div>
        }
        <div class="col-12 p-0 mt-4 text-center">
          <button type="submit" [disabled]="(op_popup_data.isPa && !bill_payer)" class="primary-btn submitButton"
          (click)="onSubmit($event)">Submit</button>
        </div>
      </div>
    }
  </div>
}
@if (show_failed_popup || (op_popup_data && !op_popup_data.pa && !eye_popup && !isoptical && !is_op_fSixty)) {
  <div>
    @if (show_err_message) {
      <label>Please Wait, Data is loading...</label>
    }
    @if (this.dialogData.type=='settlement') {
      <div class="">
        <div class="modal-header">
          <ng-container>
            <h4 class="modal-title kx-modal-heading pl-2">
              <strong>Bill created successfully.</strong>
            </h4>
          </ng-container>
        </div>
        @if (this.dialogData.response != undefined) {
          <div class="modal-body">
            <ng-container>
              @if (this.dialogData.response.resource[0] != undefined) {
                <div>
                  <p>Bill No. is {{this.dialogData.response.resource[0].bill_no}}</p>
                </div>
              }
              @if (this.dialogData.response.resource[0] != undefined) {
                <div>
                  <p>Bill Date Time is {{this.dialogData.response.resource[0].bill_date_time | dateTimeFormat}}</p>
                </div>
              }
            </ng-container>
          </div>
        }
        <div class="modal-footer">
          <button type="button" class="secondary-btn" data-dismiss="modal" (click)="hide()">
            <span>Back to List</span>
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
    @if (show_failed_popup || (this.dialogData.action != 'view' && this.dialogData.action != 'addendum' && scheme_data == undefined && this.dialogData.action != 'IMAGE_VIEWER' && this.dialogData.resource != 'tariff_service_item_service_wise' && this.dialogData.type!='settlement')) {
      <div class="dataContainer"
        >
        @if (this.dialogData.resouce) {
          <h6 style="font-size:20px">There is no price defined for following Service So
            Tariff
            changes did not
          happened.</h6>
        }
        @if (!this.dialogData.resouce && this.dialogData.resourceName != 'billingpayer_details') {
          <h6
            style="font-size:20px">There is no price defined for following Service So billing category changes did not
          happened.</h6>
        }
        @if (this.dialogData.resourceName == 'billingpayer_details') {
          <h6 style="font-size:20px">There is no price
            defined
          for following Service So Payer could not changed.</h6>
        }
        <dhs-data-grid [fields]="resourcedef.list.fields" [data]="dialogData" [config]="config">
        </dhs-data-grid>
      </div>
    }
    @if (this.dialogData.actions == 'noPackage') {
      <div class="dataContainer">
        <h6 style="font-size:20px">There is no Package selected.</h6>
        <dhs-data-grid [fields]="resourcedef.list.fields" [data]="dialogData" [config]="config">
        </dhs-data-grid>
      </div>
    }
    @if (view_count != undefined) {
      <div class="dataContainer">
        <h6 style="font-size:20px">{{pageNameTitle.page_name.list | translate |async}}</h6>
        <dhs-data-grid [fields]="resourcedef.list.fields" [data]="view_count" [config]="config"(onLimitChange)="onLimit($event)" (onPageChanges)="onPageChanged($event)"
          [filterFieldGroup]="_currentData.currentFilterListFormFields" (bindGrid)="bindDataToGrid($event)"
          (onFilterChange)="onFilter($event)">
        </dhs-data-grid>
      </div>
    }
    @if (scheme_data != undefined) {
      <div class="dataContainer">
        <dhs-form-view [fieldGroup]="fieldsform" [data]="scheme_data" [buttonConf]=false>
        </dhs-form-view>
      </div>
    }
    @if (addendumdata != undefined) {
      <div class="dataContainer">
        <dhs-data-grid [fields]="addendumfields.list.fields" [data]="addendumdata" [config]="config">
        </dhs-data-grid>
      </div>
    }
    @if (this.dialogData.action == 'IMAGE_VIEWER') {
      <div class="dataContainer backNavigationViewer">
        <app-common-viewer [resource]="{resource:{resource: 'dialogData'}}"></app-common-viewer>
      </div>
    }
    @if (tarrifData != undefined && this.dialogData.resource == 'tariff_service_item_service_wise') {
      <div class="dataContainer">
        <dhs-data-grid [fields]="resourcedef.list.fields" [data]="tarrifData" [config]="configTariff"
          (onLimitChange)="onLimit($event)" (onPageChanges)="onPageChanged($event)"
          [filterFieldGroup]="_currentData.currentFilterListFormFields" (bindGrid)="bindDataToGrid($event)"
          (onFilterChange)="onFilter($event)">
        </dhs-data-grid>
      </div>
    }
  </div>
}
@if (eye_popup && isoptical && !is_op_fSixty) {
  <div>
    <dhs-form [action]="'ADD'" [data]="opt_pop_data" [formtype]="''" (saveFinished)="onSaveFinishedopt($event)" [config]="config_opt" [fieldGroup]="eye_popup">
    </dhs-form>
  </div>
}
@if (eye_popup && is_op_fSixty) {
  <div>
    <dhs-form [action]="'ADD'" [data]="this.dialogConfig.data.data_to_fill" [formtype]="''" (saveFinished)="onSaveFinishedopt($event)" [decorator]="this.dialogConfig.data.decorator" [config]="config_opt" [fieldGroup]="eye_popup">
    </dhs-form>
  </div>
}